module.exports = __webpack_public_path__ + "static/media/03-location-detail.37b01754.png";